module.exports = __webpack_public_path__ + "fonts/4bc0d154c8af6bbfc13ef9c9803e0775.svg";